export default Object.freeze({
  LOADING: 'loading',
  SUCCESS: 'success',
  FAIL: 'fail',
});
